var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "folder"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.8458 16.1779C17.5332 16.4904 17.1093 16.666 16.6672 16.666H3.3328C2.89074 16.666 2.46678 16.4904 2.15419 16.1779C1.84161 15.8653 1.666 15.4414 1.666 14.9994V4.16659C1.666 3.72458 1.84161 3.30068 2.15419 2.98813C2.46678 2.67559 2.89074 2.5 3.3328 2.5H6.60806C6.88401 2.50005 7.15562 2.56859 7.39854 2.69949C7.64146 2.83038 7.84807 3.01953 7.99984 3.24996L8.67489 4.24992C8.82821 4.48272 9.03747 4.67335 9.28353 4.80437C9.52958 4.9354 9.80458 5.00262 10.0833 4.99988H16.6672C17.1093 4.99988 17.5332 5.17547 17.8458 5.48801C18.1584 5.80056 18.334 6.22446 18.334 6.66647V14.9994C18.334 15.4414 18.1584 15.8653 17.8458 16.1779Z",
    stroke: "#60A5FA",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.739882f4aefcca4ff974c48d61f8a66d.svg";
export { ForwardRef as ReactComponent };